import type { Colors } from '@chakra-ui/react';

export const colors: Colors = {
  error: {
    default: '#D34C46',
    muted: 'rgba(215, 56, 71, 0.1)',
  },
  success: {
    default: '#579F6E',
    muted: 'rgba(40, 167, 69, 0.1)',
  },
};
